import { format } from 'date-fns';
import { markInvalidAnchors } from 'helpers/string';
import { ComparisonChange, GroupParent } from 'clients/documents/documentsClient.types';

interface ExportReportData {
	sourceTitle: string;
	candidateTitle: string;
	sourceDate: string;
	candidateDate: string;
	changes: ComparisonChange[];
	documentTitle: string;
}

const metalektroSvg = `
<svg id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 297.6 99.2" xml:space="preserve" style="width: 140px; height: auto; cursor: pointer; margin-top: -5px;"><style type="text/css">
	.st0{fill:#273E71;}
	.st1{fill:#FF7000;}
</style><g><path class="st0" d="M62.1,63.2l-4.2-15.5l-0.2,0.1c-2.8,1.3-5.7,2.8-8.5,4.4L49,52.2v30.9h5.5V55.2l4.6,16l0,0.2h5.3l4.7-16.1 v27.9h5.6V46.9h-8.4L62.1,63.2z"></path><path class="st0" d="M91.2,56.9h-1.4c-3.2,0-5.6,0.7-7,2c-1.4,1.3-2.2,3.6-2.2,6.6v9c0,3,0.8,5.2,2.4,6.6c1.6,1.3,4,2,7.3,2h7.5 v-4.9h-8c-1.2,0-2-0.2-2.6-0.7c-0.5-0.5-0.8-1.1-0.8-2v-3.2h13.2v-7.1c0-2.7-0.7-4.8-2.1-6.2C96,57.7,93.9,56.9,91.2,56.9z  M86.4,64.5c0-0.9,0.2-1.6,0.6-2.1c0.4-0.4,1.2-0.6,2.3-0.6h2c0.8,0,1.4,0.2,1.9,0.7c0.5,0.5,0.7,1,0.7,1.7v3.2h-7.5V64.5z"></path><path class="st0" d="M112.2,50.9h-5.7v6H103v4.9h3.5v14.7c0,1.9,0.5,3.5,1.6,4.7c1.1,1.2,2.6,1.9,4.6,1.9h5.7v-4.9H114 c-0.7,0-1.2-0.1-1.5-0.3c-0.2-0.2-0.4-0.6-0.4-1.1v-15h6.2v-4.9h-6.2V50.9z"></path><path class="st0" d="M141.9,78.2c-0.2-0.1-0.3-0.3-0.3-0.6v-12c0-3-0.8-5.2-2.4-6.5c-1.6-1.4-4-2-7.3-2h-7.3v4.9h7.8 c1.2,0,2,0.2,2.6,0.7c0.5,0.5,0.8,1.1,0.8,2v1.9h-5c-5.6,0-8.4,2.8-8.4,8.3v1c0,2.6,0.7,4.5,2.1,5.7c1.3,1.1,3.5,1.7,6.3,1.7h3.7 c1.3,0,2.4-0.4,3.3-1.2c0.3,0.3,0.7,0.6,1.1,0.8c0.6,0.3,1.2,0.5,1.8,0.5h3.5v-4.6h-0.6C142.6,78.5,142.1,78.3,141.9,78.2z  M128.2,73.8c0-0.7,0.2-1.3,0.7-1.7c0.5-0.5,1.1-0.7,1.9-0.7h5v4.9c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.3-0.7,0.4-1.5,0.4h-3.7 c-0.8,0-1.3-0.1-1.6-0.4c-0.3-0.3-0.5-0.8-0.5-1.5V73.8z"></path><path class="st0" d="M155.3,78c-0.1-0.1-0.2-0.4-0.2-0.7V46.9h-5.7v30.6c0,1.9,0.5,3.3,1.6,4.2c1,0.9,2.2,1.4,3.6,1.4h3.5v-4.9 h-1.7C155.6,78.2,155.4,78.1,155.3,78z"></path><path class="st0" d="M173.1,56.9h-1.4c-3.2,0-5.6,0.7-7,2c-1.4,1.3-2.2,3.6-2.2,6.6v9c0,3,0.8,5.2,2.4,6.6c1.6,1.3,4,2,7.3,2h7.5 v-4.9h-8c-1.2,0-2-0.2-2.6-0.7c-0.5-0.5-0.8-1.1-0.8-2v-3.2h13.2v-7.1c0-2.7-0.7-4.8-2.1-6.2C177.9,57.7,175.8,56.9,173.1,56.9z  M168.3,67.5v-2.9c0-0.9,0.2-1.6,0.6-2.1c0.4-0.4,1.2-0.6,2.3-0.6h2c0.8,0,1.4,0.2,1.9,0.7c0.5,0.5,0.7,1,0.7,1.7v3.2H168.3z"></path><polygon class="st0" points="208.3,56.9 201,56.9 193.8,64.7 193.8,46.9 188.1,46.9 188.1,83.1 193.8,83.1 193.8,72 194.6,71.2  201.7,83.1 208.4,83.1 198.7,67.2  "></polygon><path class="st0" d="M220.4,50.9h-5.7v6h-3.5v4.9h3.5v14.7c0,1.9,0.5,3.5,1.6,4.7c1.1,1.2,2.6,1.9,4.6,1.9h5.7v-4.9h-4.4 c-0.7,0-1.2-0.1-1.5-0.3c-0.2-0.2-0.4-0.6-0.4-1.1v-15h6.2v-4.9h-6.2V50.9z"></path><path class="st0" d="M236.6,57.8v-0.9h-5.5v26.2h5.7V64.8c0-0.6,0.2-1.2,0.7-1.8c0.5-0.6,1.2-0.9,2.1-0.9h5v-5.1h-4.5 C238.9,56.9,237.7,57.2,236.6,57.8z"></path><path class="st0" d="M265.4,59c-1.6-1.4-4-2-7.3-2h-0.7c-3.2,0-5.7,0.7-7.3,2c-1.6,1.4-2.4,3.6-2.4,6.5v9c0,3,0.8,5.2,2.4,6.5 c1.6,1.4,4,2,7.3,2h0.7c3.2,0,5.7-0.7,7.3-2c1.6-1.4,2.4-3.6,2.4-6.5v-9C267.8,62.6,267,60.4,265.4,59z M253.5,75.5v-11 c0-0.9,0.3-1.5,0.8-2c0.6-0.5,1.4-0.7,2.6-0.7h1.8c1.2,0,2,0.2,2.6,0.7c0.5,0.5,0.8,1.1,0.8,2v11c0,0.9-0.3,1.5-0.8,2 c-0.6,0.5-1.4,0.7-2.6,0.7h-1.8c-1.2,0-2-0.2-2.6-0.7C253.7,77.1,253.5,76.4,253.5,75.5z"></path></g><g><path class="st1" d="M90.4,6.9c-2.7-1.5-6.2-1.6-9.9-0.4c-4.1,1.4-14.3,6.7-21.5,26c-0.1,0.4-0.1,0.8,0.1,1.2 c0.2,0.4,0.5,0.7,1,0.8c0.8,0.3,1.8-0.2,2.1-0.9C66.7,21.1,74,12,81.6,9.4c2.7-0.9,5.3-0.9,7.1,0.1c7.5,4.1,8,17.2,1.4,35.8 c-0.1,0.4-0.1,0.8,0.1,1.2c0.2,0.4,0.5,0.7,1,0.8c0.2,0,0.3,0.1,0.5,0.1c0.7,0,1.3-0.4,1.5-1.1C102.9,18.8,95.6,9.8,90.4,6.9z"></path><path class="st1" d="M78.8,37.2c-0.5-0.3-12.4-6.6-40.8,10.9C11.4,64.5,6.7,78,6,81.7c-0.6,2.6-0.3,4.8,0.8,6.4 c1.9,2.7,6.6,4.8,13.4,4.8c6.4,0,14.6-1.8,24.2-6.7c0.8-0.4,1.2-1.4,0.7-2.3c-0.4-0.8-1.4-1.2-2.3-0.7C24.3,92.6,12,89.8,9.5,86.2 c-0.5-0.7-0.6-2.1-0.2-3.7c1.5-7,10.3-18.9,30.5-31.4c26.3-16.2,37.2-11,37.4-10.9c0.8,0.4,1.8,0.2,2.3-0.7 C80,38.7,79.7,37.7,78.8,37.2z"></path></g></svg>
`;

const infoSvg = `
<svg style="width: 17px; height: 17px; margin-right: 4px; flex: none;" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="InfoOutlinedIcon" aria-label="title" data-mui-internal-clone-element="true">
  <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
</svg>`;

type SpreadsheetJSON = {
  style?: Array<{ label?: string; width?: number | string }>;
  values?: Array<Array<{ value?: string }>>;
};

const normalizeSpreadsheetData = (raw: any): SpreadsheetJSON | null => {
  if (!raw) return null;
  let data = raw;
  if (typeof raw === 'string') {
    try { data = JSON.parse(raw); } catch { return null; }
  }
  if (Array.isArray((data as any)?.style?.[0]) && Array.isArray((data as any)?.style?.[1])) {
    (data as any).style = (data as any).style[1];
  }
  if (!Array.isArray((data as any)?.style) || !Array.isArray((data as any)?.values)) {
    return null;
  }
  return data as SpreadsheetJSON;
};

const extractJsonTables = (det: any) => {
  const fromRaw = det?.from ?? det?.source ?? null;
  const toRaw = det?.to ?? det?.target ?? null;
  return {
    before: normalizeSpreadsheetData(fromRaw),
    after: normalizeSpreadsheetData(toRaw),
  };
};

const renderSpreadsheetTable = (
  data: SpreadsheetJSON,
  opts?: { title?: string; headerColor?: string },
): string => {
  const cols = Array.isArray(data?.style) ? data!.style! : [];
  const rows = Array.isArray(data?.values) ? data!.values! : [];

  const headerColor = opts?.headerColor || '#273e71';
  const title = (opts?.title || 'Table');

  const ths = cols.map((col, i) => {
    const width = col?.width != null ? `width:${typeof col.width === 'number' ? `${col.width}px` : String(col.width)};` : '';
    const label = (col?.label ?? '').toString();
    return `<th style="${width}">${label ? label : ''}</th>`;
  }).join('');

  const tRows = rows.map((row) => {
    const tds = (Array.isArray(row) ? row : []).map((cell: any) => {
      const v = (cell?.value ?? '').toString();
      return `<td>${v}</td>`;
    }).join('');
    return `<tr>${tds}</tr>`;
  }).join('');

  return `
    <div class="sheet">
      <div class="sheet-title" style="background:${headerColor}">${title}</div>
      <table class="sheet-table">
        <thead><tr>${ths}</tr></thead>
        <tbody>${tRows}</tbody>
      </table>
    </div>
  `;
};

const renderSpreadsheetSnapshots = (
  changeType: string,
  det: any,
  headerColor: string,
): string => {
  const { before, after } = extractJsonTables(det);

  const labelBefore = 'Before';
  const labelAfter = 'After';

  if ((changeType === 'added' || changeType === 'content_added') && after) {
    return renderSpreadsheetTable(after, { title: labelAfter, headerColor });
  }
  if ((changeType === 'deleted' || changeType === 'content_removed') && before) {
    return renderSpreadsheetTable(before, { title: labelBefore, headerColor });
  }
  if (before || after) {
    const beforeHtml = before ? renderSpreadsheetTable(before, { title: labelBefore, headerColor }) : '';
    const afterHtml = after ? renderSpreadsheetTable(after, { title: labelAfter, headerColor }) : '';
    return `${beforeHtml}${afterHtml}`;
  }

  return '<div class="json-note" style="opacity:.8">Table content unavailable</div>';
};

// @ts-ignore
const renderNumberingForPDF = (articleNumbering, blockNumbering) => {
  if (!articleNumbering || articleNumbering.length === 0) {
    if (!blockNumbering || blockNumbering.length === 0) return '';
    const firstPart = blockNumbering.slice(1, 3).map((item: { label: any; }) => item?.label || '').filter(Boolean).join('.');
    const secondPart = blockNumbering.slice(3).map((item: { label: any; }) => item?.label || '').join('.');
    return `${firstPart}${secondPart}`;
  }
  const articleText = articleNumbering.map((item: { label: any; }) => item?.label || '').filter(Boolean).join('.');
  const blockText = blockNumbering && blockNumbering.length > 0
    ? '• ' + blockNumbering.map((item: { label: any; }) => item?.label || '').join('• ')
    : '';
  return `${articleText}${blockText}`;
};

const generateReportHTML = (data: ExportReportData): string => {
  const getChangeIcon = (changeType: string) => {
    switch (changeType) {
      case 'added':
      case 'content_added':
        return '+';
      case 'deleted':
      case 'content_removed':
        return '×';
      case 'modified':
        return '↻';
      default:
        return '•';
    }
  };

  const getChangeColor = (changeType: string) => {
    switch (changeType) {
      case 'added':
      case 'content_added':
        return '#3da447';
      case 'deleted':
      case 'content_removed':
        return '#bc262c';
      case 'modified':
        return '#d5812a';
      default:
        return '#757575';
    }
  };

  const FIELDS: Array<'title' | 'subtitle' | 'text' | 'json_content'> = ['title', 'subtitle', 'text', 'json_content'];

  const normalizeType = (t?: string) => {
    if (t === 'added' || t === 'content_added') return 'added';
    if (t === 'deleted' || t === 'content_removed') return 'deleted';
    return 'modified';
  };

  const normalizeFootType = (t?: string) => {
    if (!t) return undefined;
    if (t === 'removed') return 'deleted';
    if (t === 'added' || t === 'deleted' || t === 'modified') return t;
    return undefined;
  };

  const esc = (s: any) =>
    String(s ?? '')
      .replace(/<\/?p>/gi, '')
      .replace(/\s+/g, ' ');

  const stripTags = (html: any) =>
    String(html ?? '')
      .replace(/<[^>]*>/g, '')
      .trim();

  const ENTITY_ORDER: Record<string, number> = { section: 1, article: 2, block: 3 };

  const sortParents = (change: any): GroupParent[] =>
    Array.isArray(change.grouping_parents)
      ? [...change.grouping_parents].sort(
        (a: GroupParent, b: GroupParent) =>
          (ENTITY_ORDER[a.entity_type] ?? 9) - (ENTITY_ORDER[b.entity_type] ?? 9),
      )
      : [];

  const firstLabel = (arr: any[]) =>
    Array.isArray(arr) && arr.length ? (arr[0]?.label ?? '') : '';

  const joinBullets = (arr: any[]) =>
    (Array.isArray(arr) ? arr : []).map(i => i?.label ?? '').filter(Boolean).join(' • ');

  const buildHeaderLabel = (parent: GroupParent, change: any) => {
    const useSource = change.change_type === 'deleted';
    const a = (useSource ? change.article_numbering_source : change.article_numbering_candidate) || [];
    const b = (useSource ? change.block_numbering_source : change.block_numbering_candidate) || [];

    let prefix = '';
    if (parent.entity_type === 'article') {
      const top = firstLabel(a);
      prefix = top ? `${top}` : '';
    } else if (parent.entity_type === 'block') {
      const top = firstLabel(a);
      const blockStr = joinBullets(b);
      if (top && blockStr) prefix = `${top} • ${blockStr}`;
      else if (top) prefix = `${top}`;
      else if (blockStr) prefix = blockStr;
    }

    const title = stripTags(parent.title);
    return prefix ? `${prefix}. ${title}` : title;
  };

  const renderGroupHeader = (parent: GroupParent, change: any) => {
    const cls =
      parent.entity_type === 'section'
        ? 'group-h2'
        : parent.entity_type === 'article'
          ? 'group-h3'
          : 'group-h4';
    return `<div class="${cls}">${buildHeaderLabel(parent, change)}</div>`;
  };

  const renderChangesWithGrouping = (
    changes: ComparisonChange[],
    maxArticleNumberWidth: string,
  ) => {
    let html = '';
    let prev = { section: null as any, article: null as any, block: null as any };

    for (const ch of changes) {
      const parents = sortParents(ch);

      const cur = {
        section: parents.find(p => p.entity_type === 'section')?.id ?? null,
        article: parents.find(p => p.entity_type === 'article')?.id ?? null,
        block: parents.find(p => p.entity_type === 'block')?.id ?? null,
      };

      
      if (cur.section !== prev.section && cur.section != null) {
        const p = parents.find(p => p.entity_type === 'section')!;
        html += renderGroupHeader(p, ch);
        prev.article = null;
        prev.block = null;
      }

      if (cur.article !== prev.article && cur.article != null) {
        const p = parents.find(p => p.entity_type === 'article')!;
        html += renderGroupHeader(p, ch);
        prev.block = null;
      }

      if (cur.block !== prev.block && cur.block != null) {
        const p = parents.find(p => p.entity_type === 'block')!;
        html += renderGroupHeader(p, ch);
      }

      prev = cur;
      html += renderChange(ch, maxArticleNumberWidth);
    }

    return html;
  };

  const getScopedFootnotes = (
    change: any,
    field: 'title' | 'subtitle' | 'text' | 'json_content',
  ) => {
    const scoped = change?.change_details?.[`footnotes_${field}`] || {};
    const fromRaw = scoped?.from ?? scoped?.source ?? [];
    const toRaw = scoped?.to ?? scoped?.target ?? [];
    const from = Array.isArray(fromRaw) ? fromRaw : [];
    const to = Array.isArray(toRaw) ? toRaw : [];
    const type = normalizeFootType(scoped?.change_type);
    return { from, to, type };
  };

  const renderFootList = (
    list: Array<{ title?: string; footnote?: string }>,
    isOld: boolean,
    ftType?: string | undefined,
  ) => {
    if (!list || list.length === 0) return '';

    let extraClass = '';
    if (ftType === 'added' && !isOld) {
      extraClass = ' added';
    } else if ((ftType === 'deleted') && isOld) {
      extraClass = ' removed';
    } else if (ftType === 'modified' && isOld) {
      extraClass = ' old';
    } else if (!ftType && isOld) {
      extraClass = ' old';
    }

    return list
      .map(
        (fn) =>
          `<div class="footnote-line${extraClass}">
            ${infoSvg} ${esc(fn.title || '')} - ${esc(fn.footnote || '')}
          </div>`,
      )
      .join('');
  };

  const renderJsonRow = (
    change: ComparisonChange,
    det: any,
    maxArticleNumberWidth: string,
    isFirstRow: boolean,
  ) => {
    const rawType = det?.change_type as string | undefined;
    const type = normalizeType(rawType);
    const symbol = getChangeIcon(rawType || type);
    const color = getChangeColor(rawType || type);

    const isDeletedNumbering = rawType === 'deleted' || rawType === 'content_removed';
    const articleNumbering =
      isDeletedNumbering ? change.article_numbering_source : change.article_numbering_candidate;
    const blockNumbering =
      isDeletedNumbering ? change.block_numbering_source : change.block_numbering_candidate;
    const numbering = renderNumberingForPDF(articleNumbering, blockNumbering);

    const { from: footFrom, to: footTo, type: footType } = getScopedFootnotes(change, 'json_content');

    let orderBanner = '';
    if (isFirstRow && change.change_details?.order && change.change_details.order.from !== change.change_details.order.to && change.change_type === 'modified') {
      orderBanner = `
        <div class="order-change">
          <span class="order-from">${esc(change.change_details.order.from ?? '')}</span>
          <span class="order-arrow">→</span>
          <span class="order-to">${esc(change.change_details.order.to ?? '')}</span>
        </div>
      `;
    }

    const tablesHtml = renderSpreadsheetSnapshots(rawType || type, det, color);

    const content = `
      ${orderBanner}
      ${tablesHtml}
      ${renderFootList(footFrom, true, footType)}
      ${renderFootList(footTo, false, footType)}
    `;

    const renvoiBadge = change.is_renvoi_change ? '<div class="badge renvoi-badge">R</div>' : '';
    const importantBadge = change.is_important_change ? '<div class="badge important-badge">A</div>' : '';

    return `
      <div class="change-item">
        <div class="change-indicator">
          <div class="change-icon-container">
            <div class="change-icon" style="background-color: ${color};">${symbol}</div>
          </div>
          <div class="article-number" style="width: ${maxArticleNumberWidth};">
            ${numbering}
          </div>
        </div>
        <div class="change-content">
          ${content}
        </div>
        <div class="badges">
          ${renvoiBadge}
          ${importantBadge}
        </div>
      </div>
    `;
  };


  const renderFieldRow = (
    change: ComparisonChange,
    field: 'title' | 'subtitle' | 'text' | 'json_content',
    maxArticleNumberWidth: string,
    isFirstRow: boolean,
  ) => {
    const details: any = change.change_details || {};
    const det = details?.[field];
    if (!det) return '';

    if (field === 'json_content') {
      return renderJsonRow(change, det, maxArticleNumberWidth, isFirstRow);
    }

    const type = normalizeType(det.change_type);
    const symbol = getChangeIcon(type);
    const color = getChangeColor(type);

    const articleNumbering =
      type === 'deleted' ? change.article_numbering_source : change.article_numbering_candidate;
    const blockNumbering =
      type === 'deleted' ? change.block_numbering_source : change.block_numbering_candidate;
    const numbering = renderNumberingForPDF(articleNumbering, blockNumbering);
    let orderBanner = '';
    if (isFirstRow && details?.order && details.order.from !== details.order.to && change.change_type === 'modified') {
      orderBanner = `
        <div class="order-change">
          <span class="order-from">${esc(details.order.from ?? '')}</span>
          <span class="order-arrow">→</span>
          <span class="order-to">${esc(details.order.to ?? '')}</span>
        </div>
      `;
    }

    const { from: footFrom, to: footTo, type: footType } = getScopedFootnotes(change, field);

    let content = '';
    const toHtml = markInvalidAnchors(det.to || '');
    const fromHtml = markInvalidAnchors(det.from || '');
    if (type === 'added') {
      content = `
        ${orderBanner}
        <div class="change-text">${toHtml || ''}</div>
        ${renderFootList(footTo, false, footType)}
      `;
    } else if (type === 'deleted') {
      content = `
        ${orderBanner}
        <div class="change-text">${fromHtml || ''}</div>
        ${renderFootList(footFrom, true, footType)}
      `;
    } else {
      // modified
      content = `
        ${orderBanner}
        <div class="change-text modified-old">${fromHtml || ''}</div>
        <div class="change-text modified-new">${toHtml || ''}</div>
        ${renderFootList(footFrom, true, footType)}
        ${renderFootList(footTo, false, footType)}
      `;
    }

    const renvoiBadge = change.is_renvoi_change ? '<div class="badge renvoi-badge">R</div>' : '';
    const importantBadge = change.is_important_change ? '<div class="badge important-badge">A</div>' : '';

    return `
      <div class="change-item">
        <div class="change-indicator">
          <div class="change-icon-container">
            <div class="change-icon" style="background-color: ${color};">${symbol}</div>
          </div>
          <div class="article-number" style="width: ${maxArticleNumberWidth};">
            ${numbering}
          </div>
        </div>
        <div class="change-content">
          ${content}
        </div>
        <div class="badges">
          ${renvoiBadge}
          ${importantBadge}
        </div>
      </div>
    `;
  };

  const renderFallbackRow = (change: ComparisonChange, maxArticleNumberWidth: string) => {
    const jsonDet = change.change_details?.json_content;
    if (jsonDet?.change_type) {
      return renderJsonRow(change, jsonDet, maxArticleNumberWidth, true);
    }

    const symbol = getChangeIcon(change.change_type);
    const color = getChangeColor(change.change_type);

    const articleNumbering =
      change.change_type === 'deleted' ? change.article_numbering_source : change.article_numbering_candidate;
    const blockNumbering =
      change.change_type === 'deleted' ? change.block_numbering_source : change.block_numbering_candidate;
    const numbering = renderNumberingForPDF(articleNumbering, blockNumbering);
    const sourceTitle = change.title_source || '';
    const targetTitle = change.title_candidate || '';
    const sourceText = change.text_source || '';
    const targetText = change.text_candidate || '';

    let content = '';
    const beforeHtml = markInvalidAnchors(sourceTitle || sourceText);
    const afterHtml = markInvalidAnchors(targetTitle || targetText);
    if (change.change_type === 'added') {
      content = `<div class="change-text">${afterHtml}</div>`;
    } else if (change.change_type === 'deleted') {
      content = `<div class="change-text">${beforeHtml}</div>`;
    } else {
      let orderBanner = '';
      if (change.change_details?.order && change.change_details.order.from !== change.change_details.order.to) {
        orderBanner = `
          <div class="order-change">
            <span class="order-from">${esc(change.change_details.order.from ?? '')}</span>
            <span class="order-arrow">→</span>
            <span class="order-to">${esc(change.change_details.order.to ?? '')}</span>
          </div>
        `;
      }
      content = `
        ${orderBanner}
        <div class="change-text modified-old">${beforeHtml}</div>
        <div class="change-text modified-new">${afterHtml}</div>
      `;
    }

    const renvoiBadge = change.is_renvoi_change ? '<div class="badge renvoi-badge">R</div>' : '';
    const importantBadge = change.is_important_change ? '<div class="badge important-badge">A</div>' : '';

    return `
      <div class="change-item">
        <div class="change-indicator">
          <div class="change-icon-container">
            <div class="change-icon" style="background-color: ${color};">${symbol}</div>
          </div>
          <div class="article-number" style="width: ${maxArticleNumberWidth};">
            ${numbering}
          </div>
        </div>
        <div class="change-content">
          ${content}
        </div>
        <div class="badges">
          ${renvoiBadge}
          ${importantBadge}
        </div>
      </div>
    `;
  };

  const renderChange = (change: ComparisonChange, maxArticleNumberWidth: string) => {
    const details: any = change.change_details || {};
    let presentFields = FIELDS.filter((f) => !!details?.[f]);

    if (details?.json_content?.change_type && change.change_type !== 'modified') {
      presentFields = ['json_content'];
    }

    if (presentFields.length === 0) {
      return renderFallbackRow(change, maxArticleNumberWidth);
    }

    let isFirst = true;
    return presentFields
      .map((field) => {
        const html = renderFieldRow(change, field, maxArticleNumberWidth, isFirst);
        isFirst = false;
        return html;
      })
      .join('');
  };

  const maxArticleNumberWidth = (() => {
    const maxCount = data.changes.reduce((max, change) => {
      const useCandidate = change.change_type !== 'deleted';
      const article = useCandidate ? change.article_numbering_candidate : change.article_numbering_source;
      const block = useCandidate ? change.block_numbering_candidate : change.block_numbering_source;
      const count = (article || []).length + (block || []).length;
      return count > max ? count : max;
    }, 0);
    return `${Math.max(maxCount * 18, 32)}px`;
  })();

  return `
    <!DOCTYPE html>
    <html lang="nl">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Overzicht van wijzigingen</title>
      <style>
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.3;
          color: #424242;
          font-size: 14px;
          background-color: #f8f9fa;
          padding: 20px;
        }
        br {
          display: none;
        }
        .page {
          max-width: 100%;
          margin: 0 auto;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        .header {
          padding: 24px;
          border-bottom: 1px solid #e0e0e0;
          background: white;
          border-radius: 8px 8px 0 0;
        }
        .header h1 {
          font-size: 18px;
          margin-bottom: 16px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .version-selects {
          display: flex;
          gap: 16px;
          margin-bottom: 16px;
        }
        .version-select {
          flex: 1;
          padding: 8px 12px;
          background: white;
          border: 1px solid #d0d7de;
          border-radius: 6px;
          font-size: 14px;
          color: #424242;
        }
        .filter-info {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #666;
          font-size: 12px;
        }
        .changes-container {
          background: #f8f9fa;
          padding: 16px;
          border-radius: 0 0 8px 8px;
        }
        .changes-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .change-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          padding: 12px;
          background: #f8f9fa;
          border-radius: 8px;
          border: none;
          width: 100%;
        }
        .change-item:hover {
          background: #f5f5f5;
        }
        .change-indicator {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .change-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .change-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 13px;
          font-weight: 400;
          flex-shrink: 0;
        }
        .article-number {
          font-weight: 500;
          color: #1a1a1a;
          font-size: 13px;
          flex-shrink: 0;
          text-align: left;
          line-height: 1.3;
        }
        .change-content {
          flex: 1;
          max-width: 500px;
        }
        .change-text {
          font-size: 13px;
          line-height: 1.3;
          margin-bottom: 0;
          overflow: hidden;
          color: #424242;
        }
        .change-text.modified-old {
          color: #9e9e9e;
          margin-bottom: 2px;
        }
        .change-text.modified-new {
          color: #424242;
        }
        .order-change {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;
          font-size: 13px;
        }
        .order-from,
        .order-to {
          color: #424242;
          line-height: 1.3;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .order-arrow {
          color: #424242;
          font-weight: normal;
          flex-shrink: 0;
        }
        .badges {
          display: flex;
          gap: 4px;
          align-items: center;
          flex-shrink: 0;
        }
        .badge {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          min-width: 24px;
          height: 24px;
          border-radius: 50%;
          font-size: 10px;
          font-weight: 500;
          border: 1px solid #222;
          color: #222;
          background: transparent;
        }
        .renvoi-badge {
          text-decoration: line-through;
        }
        .footnote-line {
          font-size: 12px;
          color: #424242;
          margin-top: 2px;
          display: flex;
          align-items: center;
        }
        .footnote-line.old {
          color: #9e9e9e;
          display: flex;
          align-items: center;
        }
        .footer {
          margin-top: 40px;
          padding: 20px;
          border-top: 1px solid #e0e0e0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #666;
          background: white;
        }
        .pragmado-logo {
          color: #1976d2;
          font-weight: 700;
          font-size: 14px;
        }
        .export-info {
          text-align: right;
          line-height: 1.4;
        }
        a[data-invalid-footnote="1"] {
          display: inline;
          background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 50%, lightgrey 50%);
          background-size: 4px 2px;
          background-repeat: repeat-x;
          background-position: 0 100%;
          text-decoration: none;
          pointer-events: none;
          color: black;
          cursor: default;
        }
        @media print {
          body {
            padding: 0;
            background: white;
          }
          .page {
            box-shadow: none;
            border-radius: 0;
          }
          .header {
            border-radius: 0;
          }
          .changes-container {
            border-radius: 0;
          }
        }
        .footnote-line {
          font-size: 12px;
          margin-top: 2px;
          color: #424242;
        }
        .footnote-line.old { color: #9e9e9e; }
        .footnote-line.added {
          color: #3da447;
          display: flex;
          align-items: center;
        }
        .footnote-line.removed {
          color: #bc262c;
          display: flex;
          align-items: center;
        }
        .group-h2 {
          margin: 16px 0 8px;
          font-weight: 600;
          font-size: 15px;
          color: #4C4E4E;
        }
        .group-h3 {
          margin: 12px 0 6px;
          font-weight: 600;
          font-size: 14px;
          color: #4C4E4E;
          padding-left: 4px;
        }
        .group-h4 {
          margin: 8px 0 6px;
          font-weight: 600;
          font-size: 13px;
          color: #4C4E4E;
          padding-left: 8px;
        }
        .sheet {
          width: 100%;
          margin: 4px 0 6px;
          border: 0.75px solid #e0e0e0;
          overflow: hidden;
          page-break-inside: avoid;
          background: #fff;
        }

        .sheet-title {
          color: #fff;
          font-weight: 700;
          font-size: 12px;
          padding: 6px 8px;
        }

        .sheet-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }

        .sheet-table th, .sheet-table td {
          border: 0.75px solid #e4e4e4;
          padding: 4px 6px;
          font-size: 11px;
          line-height: 1.2;
          vertical-align: top;
          word-break: break-word;
          white-space: normal;
        }

        .sheet-table th {
          background: #f4f6f8;
          color: #1a1a1a;
          font-weight: 600;
          text-align: left;
        }
      </style>
    </head>
    <body>
      <div class="page">
        <div class="header">
          <h1>Overzicht van wijzigingen</h1>
          <div class="version-selects">
            <div class="version-select">${data.sourceTitle} (${data.sourceDate})</div>
            <div class="version-select">${data.candidateTitle} (${data.candidateDate})</div>
          </div>
          <div class="filter-info">
            Totaal ${data.changes.length} wijziging${data.changes.length !== 1 ? 'en' : ''}
          </div>
        </div>

        <div class="changes-container">
          <div class="changes-list">
            ${renderChangesWithGrouping(data.changes, maxArticleNumberWidth)}
          </div>
        </div>

        <div class="footer">
          ${metalektroSvg}
          <div class="export-info">
            Gegenereerd op ${new Date().toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })} om ${new Date().toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};


export const exportChangesReportAsPDF = async (
  comparisonData: ComparisonChange[],
  sourceVersion: string,
  candidateVersion: string,
  documentTitle: string = 'COLLECTIEVE ARBEIDSOVEREENKOMSTEN IN DE METALEKTRO',
  sourceDate?: string,
  candidateDate?: string,
) => {
  const reportData: ExportReportData = {
    sourceTitle: sourceVersion,
    candidateTitle: candidateVersion,
    sourceDate: sourceDate || format(new Date(), 'dd-MM-yyyy'),
    candidateDate: candidateDate || format(new Date(), 'dd-MM-yyyy'),
    changes: comparisonData,
    documentTitle,
  };

  const htmlContent = generateReportHTML(reportData);

  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    throw new Error('Could not open print window. Please allow popups for this site.');
  }

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  await new Promise(resolve => {
    printWindow.onload = resolve;
    setTimeout(resolve, 1000);
  });

  printWindow.focus();
  printWindow.print();

  setTimeout(() => {
    printWindow.close();
  }, 1500);
};

export const handleExportClick = async (
  comparisonData: ComparisonChange[],
  versions: any[],
  sourceVersionSlug: string,
  candidateVersionSlug: string,
  candidateIsDraft: boolean,
) => {
  try {
    const sourceVersion = versions.find(v => v.slug === sourceVersionSlug);
    const candidateVersion = candidateIsDraft
      ? null
      : versions.find(v => v.slug === candidateVersionSlug);

    const sourceDate = sourceVersion?.published_at
      ? format(new Date(sourceVersion.published_at), 'dd-MM-yyyy')
      : format(new Date(), 'dd-MM-yyyy');

    const candidateDate = candidateIsDraft
      ? format(new Date(), 'dd-MM-yyyy')
      : candidateVersion?.published_at
        ? format(new Date(candidateVersion.published_at), 'dd-MM-yyyy')
        : format(new Date(), 'dd-MM-yyyy');

    await exportChangesReportAsPDF(
      comparisonData,
      sourceVersion?.title || sourceVersionSlug,
      candidateIsDraft ? 'Werkversie' : (candidateVersion?.title || candidateVersionSlug),
      'COLLECTIEVE ARBEIDSOVEREENKOMSTEN IN DE METALEKTRO',
      sourceDate,
      candidateDate,
    );
  } catch (error) {
    console.error('Failed to export PDF:', error);
    alert('Er is een fout opgetreden bij het exporteren. Zorg ervoor dat popups zijn toegestaan.');
  }
};